export default __webpack_public_path__ + "static/media/86325fbd-e8b4-4dac-9ef1-db2fe27d3182.75341116.png";